import type React from "react";

import { useTranslation } from "react-i18next";

import { EmailForm } from "../components/Forms";
import { LoginContainer } from "../components/LoginContainer";
import { LoginInfoContainer } from "../components/LoginInfoContainer";
import { LoginWrapper } from "../components/styledComponents";

export const Email: React.FC = () => {
  const { t } = useTranslation();

  return (
    <LoginWrapper>
      <LoginContainer>
        <LoginInfoContainer title={t("login.info.email.title")} />
        <EmailForm />
      </LoginContainer>
    </LoginWrapper>
  );
};
